import { render, staticRenderFns } from "./CorootOnVM.vue?vue&type=template&id=183e5932&scoped=true"
import script from "./CorootOnVM.vue?vue&type=script&lang=js"
export * from "./CorootOnVM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e5932",
  null
  
)

export default component.exports